import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=354310ad&"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=354310ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports